import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import PrivateRoute from "@/routes/PrivateRoute";

import Login from "@/pages/auth/Login";
import Dashboard from "@/pages/dashboard/Dashboard";

import ClientesList from "@/pages/clientes/ClientesList";
import ClienteForm from "@/pages/clientes/ClienteForm";
import ClienteVeiculos from "@/pages/clientes/ClienteVeiculos";

import VeiculosList from "@/pages/veiculos/VeiculosList";

import PecasList from "@/pages/pecas/PecasList";
import PecaForm from "@/pages/pecas/PecaForm";
import PecaHistorico from "@/pages/pecas/PecaHistorico";

import EstoqueMovimentar from "@/pages/estoque/EstoqueMovimentar";

import OSList from "@/pages/os/OSList";
import OSNew from "@/pages/os/OSNew";
import OSShow from "@/pages/os/OSShow";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 🔓 Pública */}
        <Route path="/login" element={<Login />} />

        {/* 🔐 Dashboard */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* 🔐 Clientes */}
        <Route
          path="/clientes"
          element={
            <PrivateRoute>
              <ClientesList />
            </PrivateRoute>
          }
        />
        <Route
          path="/clientes/novo"
          element={
            <PrivateRoute>
              <ClienteForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/clientes/:id/editar"
          element={
            <PrivateRoute>
              <ClienteForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/clientes/:id/veiculos"
          element={
            <PrivateRoute>
              <ClienteVeiculos />
            </PrivateRoute>
          }
        />

        {/* 🔐 Veículos */}
        <Route
          path="/veiculos"
          element={
            <PrivateRoute>
              <VeiculosList />
            </PrivateRoute>
          }
        />

        {/* 🔐 Peças */}
        <Route
          path="/pecas"
          element={
            <PrivateRoute>
              <PecasList />
            </PrivateRoute>
          }
        />
        <Route
          path="/pecas/nova"
          element={
            <PrivateRoute>
              <PecaForm mode="create" />
            </PrivateRoute>
          }
        />
        <Route
          path="/pecas/:id/editar"
          element={
            <PrivateRoute>
              <PecaForm mode="edit" />
            </PrivateRoute>
          }
        />
        <Route
          path="/pecas/:id/historico"
          element={
            <PrivateRoute>
              <PecaHistorico />
            </PrivateRoute>
          }
        />

        {/* 🔐 Estoque */}
        <Route
          path="/estoque/movimentar"
          element={
            <PrivateRoute>
              <EstoqueMovimentar />
            </PrivateRoute>
          }
        />

        {/* 🔐 OS */}
        <Route
          path="/os"
          element={
            <PrivateRoute>
              <OSList />
            </PrivateRoute>
          }
        />
        <Route
          path="/os/nova"
          element={
            <PrivateRoute>
              <OSNew />
            </PrivateRoute>
          }
        />
        <Route
          path="/os/:id"
          element={
            <PrivateRoute>
              <OSShow />
            </PrivateRoute>
          }
        />

        {/* fallback */}
        {/* <Route path="*" element={<Navigate to="/os" replace />} /> */}
      </Routes>
    </BrowserRouter>
  );
}
